import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";
import { useL10n } from "@ews/react-localization-context";
import { TooltipIcon } from "../../../ToolTip/useTooltip";

const TriggeredFireProtectionSystems: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();
    return <>
        <SettingsCheckbox
            text={t("[REACT_GAS_EXTINGUISHING_SYSTEM]")}
            tooltip={<TooltipIcon text={t("REACT_GAS_EXTINGUISHING_SYSTEM")} />}
            checked={specification.triggeredFireProtectionSystems?.gasExtinguishingSystem || false}
            onChange={(checked) =>
            {
                if (specification.triggeredFireProtectionSystems?.gasExtinguishingSystem === checked) return;
                if (systemId && specification.triggeredFireProtectionSystems) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        triggeredFireProtectionSystems: {
                            ...specification.triggeredFireProtectionSystems,
                            gasExtinguishingSystem: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("[REACT_SMOKE_AND_HEAT_EXHAUST_SYSTEM]")}
            tooltip={<TooltipIcon text={t("[REACT_SMOKE_AND_HEAT_EXHAUST_SYSTEM]")} />}
            checked={specification.triggeredFireProtectionSystems?.smokeAndHeatExtractionSystem || false}
            onChange={(checked) =>
            {
                if (specification.triggeredFireProtectionSystems?.smokeAndHeatExtractionSystem === checked) return;
                if (systemId && specification.triggeredFireProtectionSystems) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        triggeredFireProtectionSystems: {
                            ...specification.triggeredFireProtectionSystems,
                            smokeAndHeatExtractionSystem: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("[REACT_FORCED_VENTILATION_SYSTEM]")}
            tooltip={<TooltipIcon text={t("[REACT_FORCED_VENTILATION_SYSTEM]")} />}
            checked={specification.triggeredFireProtectionSystems?.directlyConnectedAlarmSystem || false}
            onChange={(checked) =>
            {
                if (specification.triggeredFireProtectionSystems?.directlyConnectedAlarmSystem === checked) return;
                if (systemId && specification.triggeredFireProtectionSystems) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        triggeredFireProtectionSystems: {
                            ...specification.triggeredFireProtectionSystems,
                            directlyConnectedAlarmSystem: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("[REACT_ELECTRO_ACOUSTIC_EMERGENCY_WARNING_SYSTEM]")}
            tooltip={<TooltipIcon text={t("[REACT_ELECTRO_ACOUSTIC_EMERGENCY_WARNING_SYSTEM]")} />}
            checked={specification.triggeredFireProtectionSystems?.electricalNotificationSystem || false}
            onChange={(checked) =>
            {
                if (specification.triggeredFireProtectionSystems?.electricalNotificationSystem === checked) return;
                if (systemId && specification.triggeredFireProtectionSystems) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        triggeredFireProtectionSystems: {
                            ...specification.triggeredFireProtectionSystems,
                            electricalNotificationSystem: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("[REACT_PRE-PILOTED_SPRINKLER_SYSTEM]")}
            tooltip={<TooltipIcon text={t("[REACT_PRE-PILOTED_SPRINKLER_SYSTEM]")} />}
            checked={specification.triggeredFireProtectionSystems?.preControlledSprinklerSystem || false}
            onChange={(checked) =>
            {
                if (specification.triggeredFireProtectionSystems?.preControlledSprinklerSystem === checked) return;
                if (systemId && specification.triggeredFireProtectionSystems) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        triggeredFireProtectionSystems: {
                            ...specification.triggeredFireProtectionSystems,
                            preControlledSprinklerSystem: checked
                        },
                    });
                }
            }} />
    </>;
};

export default TriggeredFireProtectionSystems;
